import { render, staticRenderFns } from "./materialSummary.pug?vue&type=template&id=7d751919&lang=pug&"
import script from "./materialSummary.js?vue&type=script&lang=js&"
export * from "./materialSummary.js?vue&type=script&lang=js&"
import style0 from "./materialSummary.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CVM7Z9V\\OneDrive - Allianz\\Escritorio\\apps\\mavalue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d751919')) {
      api.createRecord('7d751919', component.options)
    } else {
      api.reload('7d751919', component.options)
    }
    module.hot.accept("./materialSummary.pug?vue&type=template&id=7d751919&lang=pug&", function () {
      api.rerender('7d751919', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/warrantyLayout/components/warrantySticky/components/materialSummary/index.vue"
export default component.exports